module.exports = __webpack_public_path__ + "500928015242548a543db59310cc0dec.svg";